"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SvgArrowLang = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
exports.SvgArrowLang = () => (React.createElement("svg", { width: "12", height: "7", viewBox: "0 0 12 7", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M11 1L6 6L1 1", stroke: "#646464" })));
//# sourceMappingURL=SvgArrowLang.js.map